import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { Dialog } from 'evergreen-ui';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Avatar
} from "@mui/material";
import {
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  CreditCard as CreditCardIcon,
  AccountBalance as BankIcon,
  CheckCircle as CheckIcon,
  Pending as PendingIcon
} from "@mui/icons-material";
const cookies = new Cookies();
const token = cookies.get("token")
const language = cookies.get("language") ? cookies.get("language") : "ar"
export const OnlineInvoicePreview = (props) => {
    const [loading, setloading] = useState(true);

    useEffect(() => {
        setloading(false)
        return () => {
            console.log("props.invoice",props?.invoice);
        };
    }, [loading, props.show]);


    return (
        
            <Dialog
                isShown={props.show}
                onCloseComplete={() => props.setShow(false)}
                hasHeader={true}
                title="Invoice Details"
                shouldCloseOnOverlayClick={false}
                hasFooter={false}
                width={'100%'}
                onConfirm={() => { }}
            >
                {loading ? <></> :
                    <Box sx={{ fontFamily: 'Cairo, sans-serif', p: 2 }}>
                        {props?.invoice ? (
                            <>
                                {/* Header Section */}
                                <Card sx={{ mb: 3, background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                                    <CardContent sx={{ p: 3 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                            <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)', mr: 2 }}>
                                                <ReceiptIcon />
                                            </Avatar>
                                            <Typography variant="h5" fontWeight="600">
                                                Invoice #{props.invoice.invoice_number}
                                            </Typography>
                                        </Box>
                                        <Typography variant="body1" sx={{ opacity: 0.9 }}>
                                            Receipt Date: {props.invoice.receipt_date}
                                        </Typography>
                                    </CardContent>
                                </Card>

                                {/* Main Invoice Details */}
                                <Grid container spacing={3} sx={{ mb: 3 }}>
                                    <Grid item xs={12} md={6}>
                                        <Card sx={{ height: '100%', border: '1px solid #e5e7eb' }}>
                                            <CardContent>
                                                <Typography variant="h6" fontWeight="600" color="#1f2937" gutterBottom>
                                                    Invoice Information
                                                </Typography>
                                                <Divider sx={{ mb: 2 }} />
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                    <Box>
                                                        <Typography variant="body2" color="#6b7280" fontWeight="500">
                                                            Receipt Number
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="600" color="#1f2937">
                                                            {props.invoice.receipt_number}
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography variant="body2" color="#6b7280" fontWeight="500">
                                                            Total Amount
                                                        </Typography>
                                                        <Typography variant="h6" fontWeight="700" color="#059669">
                                                            {props.invoice.amount.toLocaleString()} {props.invoice.currency}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                    
                                    <Grid item xs={12} md={6}>
                                        <Card sx={{ height: '100%', border: '1px solid #e5e7eb' }}>
                                            <CardContent>
                                                <Typography variant="h6" fontWeight="600" color="#1f2937" gutterBottom>
                                                    Payment Details
                                                </Typography>
                                                <Divider sx={{ mb: 2 }} />
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                                    <Box>
                                                        <Typography variant="body2" color="#6b7280" fontWeight="500" gutterBottom>
                                                            Payment Status
                                                        </Typography>
                                                        <Chip
                                                            icon={props.invoice.payment_master?.status === 'DEPOSITED' ? <CheckIcon /> : <PendingIcon />}
                                                            label={props.invoice.payment_master?.status || 'PENDING'}
                                                            color={props.invoice.payment_master?.status === 'DEPOSITED' ? 'success' : 'warning'}
                                                            variant="filled"
                                                        />
                                                    </Box>
                                                    <Box>
                                                        <Typography variant="body2" color="#6b7280" fontWeight="500">
                                                            Payment Method
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="600" color="#1f2937">
                                                            {props.invoice.payment_master?.payment_method || 'N/A'}
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography variant="body2" color="#6b7280" fontWeight="500">
                                                            Paid Amount
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="600" color="#1f2937">
                                                            {props.invoice.payment_master?.paid_amount?.toLocaleString() || '0'} {props.invoice.currency}
                                                        </Typography>
                                                    </Box>
                                                    {props.invoice.payment_master?.bank_trx_id && (
                                                        <Box>
                                                            <Typography variant="body2" color="#6b7280" fontWeight="500">
                                                                Transaction ID
                                                            </Typography>
                                                            <Typography variant="body1" fontWeight="600" color="#1f2937">
                                                                {props.invoice.payment_master.bank_trx_id}
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>

                                {/* Sub Invoices Section */}
                                {props.invoice.sub_invoices?.length > 0 && (
                                    <Card sx={{ mb: 3, border: '1px solid #e5e7eb' }}>
                                        <CardContent>
                                            <Typography variant="h6" fontWeight="600" color="#1f2937" gutterBottom>
                                                Sub Invoices
                                            </Typography>
                                            <Divider sx={{ mb: 2 }} />
                                            <TableContainer component={Paper} elevation={0}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow sx={{ bgcolor: '#f9fafb' }}>
                                                            <TableCell sx={{ fontWeight: 600, color: '#374151' }}>Bill Number</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, color: '#374151' }}>Balance</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, color: '#374151' }}>New Balance</TableCell>
                                                            <TableCell sx={{ fontWeight: 600, color: '#374151' }}>Currency</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {props.invoice.sub_invoices.map((subInvoice, index) => (
                                                            <TableRow key={index} sx={{ '&:hover': { bgcolor: '#f9fafb' } }}>
                                                                <TableCell sx={{ color: '#1f2937' }}>{subInvoice.bill_number}</TableCell>
                                                                <TableCell sx={{ color: '#1f2937' }}>{subInvoice.balance.toLocaleString()}</TableCell>
                                                                <TableCell sx={{ color: '#1f2937' }}>{subInvoice.new_balance.toLocaleString()}</TableCell>
                                                                <TableCell sx={{ color: '#1f2937' }}>{subInvoice.currency==4?"IQD":"USD"}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </CardContent>
                                    </Card>
                                )}

                                {/* Online Payment Details */}
                                {props.invoice.payment_master?.extra_data?.online_payment && (
                                    <Card sx={{ mb: 3, border: '1px solid #e5e7eb' }}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                <Avatar sx={{ bgcolor: '#3b82f6', mr: 2, width: 32, height: 32 }}>
                                                    <CreditCardIcon fontSize="small" />
                                                </Avatar>
                                                <Typography variant="h6" fontWeight="600" color="#1f2937">
                                                    Online Payment Details
                                                </Typography>
                                            </Box>
                                            <Divider sx={{ mb: 2 }} />
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <Box>
                                                        <Typography variant="body2" color="#6b7280" fontWeight="500">
                                                            Card Number
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="600" color="#1f2937">
                                                            **** **** **** {props.invoice.payment_master.extra_data.online_payment.pan}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Box>
                                                        <Typography variant="body2" color="#6b7280" fontWeight="500">
                                                            Authorization ID
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="600" color="#1f2937">
                                                            {props.invoice.payment_master.extra_data.online_payment.authorizationResponseId}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Box>
                                                        <Typography variant="body2" color="#6b7280" fontWeight="500">
                                                            Payment Way
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="600" color="#1f2937">
                                                            {props.invoice.payment_master.extra_data.online_payment.paymentWay}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Box>
                                                        <Typography variant="body2" color="#6b7280" fontWeight="500">
                                                            IP Address
                                                        </Typography>
                                                        <Typography variant="body1" fontWeight="600" color="#1f2937">
                                                            {props.invoice.payment_master.extra_data.online_payment.Ip}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                )}
                            </>
                        ) : (
                            <Card sx={{ p: 3, textAlign: 'center' }}>
                                <Typography variant="h6" color="#6b7280">
                                    No invoice data available
                                </Typography>
                            </Card>
                        )}
                    </Box>
                }
            </Dialog>

    );
};


export default OnlineInvoicePreview;
